var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackVibes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.77 307.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "19.66 0 51.25 0 51.25 148.19 19.66 148.19 19.66 5.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "64.88 0 98.6 0 98.6 148.19 64.88 148.19 64.88 5.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0 154.62 27.75 154.62 27.75 302.82 0 302.82 0 160.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "39.21 155.4 72.94 155.4 72.94 303.61 39.21 303.61 39.21 161.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "82.56 154.62 116.29 154.62 116.29 302.82 82.56 302.82 82.56 160.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "128.01 154.62 156.63 154.62 156.63 302.82 128.01 302.82 128.01 160.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.15 157.48 194.59 153.62 215.21 300.38 187.77 304.23 167.97 163.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.32 0 144.07 0 144.07 148.19 110.32 148.19 110.32 5.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "217.78 157.89 251.51 157.29 254.1 305.46 220.37 306.05 217.89 163.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "202.71 0 236.46 0 236.46 148.19 202.71 148.19 202.71 5.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "264.54 159.59 291.82 159.59 291.82 307.79 264.54 307.79 264.54 165.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "309.12 159.59 332.77 159.59 332.77 307.79 309.12 307.79 309.12 165.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "247.68 0 272.67 0 272.67 148.19 247.68 148.19 247.68 5.92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackVibes);
export default __webpack_public_path__ + "static/media/BlackVibes.fbf7be8b3edcea28a4d4a43d83953b21.svg";
export { ForwardRef as ReactComponent };